export default class Attendance {
  constructor() {
    this.identifier = null;
    this.logged = false;
    this.agentId = '';
    this.agentName = '';
    this.viewModalFeedback = false;
    this.channels = {};
    this.timeInformations = {
      totalLoginTimeDuration: 0,
      whatsapp: {
        totalLoggedTime: 0,
        pausesTime: [],
        activeAttendances: [],
        currentStatusTime: 0,
      },
      chat: {
        totalLoggedTime: 0,
        pausesTime: [],
        activeAttendances: [],
        currentStatusTime: 0,
      },
      voice: {
        totalLoggedTime: 0,
        pausesTime: [],
        activeAttendances: [],
        currentStatusTime: 0,
      },
    };
    this.avatar = null;
    this.campaignVoiceDefault = null;
    this.campaignWhatsappDefault = null;
  }
}
